<template>
    <div class="home-form gift-recipient_detail">
        <fieldset>
            <div v-if="multipleRecipients" class="recipient-num-wrapper">
                <p  class="receipt-num-line"><span class="receipt-num">Friend #{{ recipientOrder + 1 }}</span></p>
                <div v-if="removable" class="remove-recipient-button" @click="$emit('remove', recipientKey)">&times;</div>
            </div>

            <!-- Recipient Name -->
            <div class="input-group">
                <input type="text" placeholder="Their Name" v-model="$v.recipientName.$model" :class="validationStatus($v.recipientName)" autocomplete="off">
            </div>
            <div class="error-msg" v-if="showValidationErrors && (!$v.recipientName.required)">Name is required.</div>

            <!-- Email -->
            <div class="input-group">
                <input type="text" placeholder="Their Email" v-model.lazy="$v.recipientEmail.$model" :class="validationStatus($v.recipientEmail)" autocomplete="off">
                <div class="error-msg" v-if="showValidationErrors && (!$v.recipientEmail.notUserEmail)">Email cannot be users.</div>
            </div>
            <div class="error-msg" v-if="showValidationErrors && !$v.recipientEmail.required">Email is required.</div>
            <div class="error-msg" v-if="showValidationErrors && !$v.recipientEmail.email">Email is invalid.</div>
        </fieldset>
    </div>
</template>

<script>
    import { validationMixin } from 'vuelidate';
    import { required, email } from 'vuelidate/lib/validators';

    const notUserEmail =
        (value, vm) => (value !== vm.userEmail);

    export default {
        mixins: [
            validationMixin
        ],
        props: {
            multipleRecipients: Boolean,
            removable: Boolean,
            recipientKey: Number,
            recipientOrder: Number,
            userEmail: String
        },
        data: function () {
            return {
                recipientName: undefined,
                recipientEmail: undefined,
                showValidationErrors: false,
            }
        },
        validations: {
            recipientName: {
                required
            },
            recipientEmail: {
                required,
                email,
                notUserEmail
            }
        },
        methods: {
            getRecipientDetail() {
                return {
                    name: this.recipientName,
                    email: this.recipientEmail
                }
            },
            validationStatus(validation) {
                return {
                    'input-error': validation.$error
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/variables_home";
    @import "../../../styles/common_home";
    @import "../../../styles/form_home.scss";

    .gift-recipient_detail {
        margin-top: 2rem;
    }
    .recipient-num-wrapper {
        position: relative;
    }
    .receipt-num-line {
        border-bottom: solid 1px lighten($color-primary, 50%);
        line-height: 0;
        margin-right: 24px;
    }
    .receipt-num {
        padding: 0 1rem;
        background-color: $white;
        position: relative;
        left: 24px;
    }
    .remove-recipient-button {
        position: absolute;
        top: -8px;
        right: 4px;
        font-size: 24px;
        cursor: pointer;
        &:hover {
            color: darken($color-primary, 30%);
        }
        &:active {
            font-weight: bold;
        }
    }
    input {
        width: 100%;
        padding: 8px 14px;
    }
    .input-group {
        margin-top: 1.5rem;
        align-items: center;
        justify-content: space-between;
    }
    fieldset {
        margin-top: 0;
    }
    .error-msg {
        top: 0;
    }

    @media only screen and (max-width: $max-mobile-width) {
    }
</style>
